import { Card, CardActionArea, CardContent, Skeleton, Typography, useTheme } from '@mui/material';

interface DashboardCardProps {
  title: string;
  description?: string;
  onClickHandler: (e: React.MouseEvent) => void;
  subtitle?: string;
  value?: number | null;
  borderColor?: string;
  isLoading?: boolean;
}
export const DashboardCard = ({
  title,
  onClickHandler,
  subtitle,
  value,
  borderColor,
  description = '',
  isLoading = false,
}: DashboardCardProps) => {
  const theme = useTheme();
  if (isLoading) {
    return <Skeleton variant="rectangular" width="315px" height="150px" />;
  }
  return (
    <Card
      sx={{
        width: '315px',
        height: '150px',
        border: (theme) => `1px solid ${theme.palette.divider}`,
      }}
    >
      <CardActionArea
        onClick={(e) => onClickHandler(e)}
        sx={{
          height: '100%',
          '&[data-active]': {
            backgroundColor: 'action.selected',
            '&:hover': {
              backgroundColor: 'action.selectedHover',
            },
          },
        }}
      >
        <CardContent
          sx={{
            height: '100%',
            borderLeft: (theme) => `3px solid ${borderColor ?? theme.palette.primary.main}`,
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: '500' }}>
            {title}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              minHeight: theme.spacing(6),
            }}
          >
            {subtitle ?? ''}
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: '500' }}>
            {value ?? '--'}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            {description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};
